import BuilderAddToPortfolioSuccess from './BuilderAddToPortfolioSuccess';

export default BuilderAddToPortfolioSuccess;
